// privatokonomi-messages-part2 translations (English catalog).
window.PlummeI18n.register('en', {
  'pkn.gj.journey.debtFree': 'Completely debt-free',
  'pkn.gj.now': 'Now',
  'pkn.gj.fillRequired': 'Enter name, remaining balance and interest rate',
  'pkn.gj.editLoan': 'Edit loan',
  'pkn.gj.addLoan': 'Add loan',
  'pkn.gj.fieldName': 'Loan name',
  'pkn.gj.phName': 'E.g. Home loan',
  'pkn.gj.fieldLender': 'Lender / type',
  'pkn.gj.phLender': 'E.g. Annuity loan · DNB',
  'pkn.gj.fieldBalance': 'Remaining balance (kr)',
  'pkn.gj.fieldOriginal': 'Original loan (kr)',
  'pkn.gj.optionalLower': 'optional',
  'pkn.gj.fieldNominal': 'Nominal interest (%)',
  'pkn.gj.fieldEffective': 'Effective interest (%)',
  'pkn.gj.optionalUpper': 'Optional',
  'pkn.gj.fieldTerm': 'Remaining months',
  'pkn.gj.annuityLoan': 'Annuity loan',
  'pkn.gj.serialLoan': 'Serial loan',
  'pkn.gj.serialHint': 'Serial loan: fixed principal each month — the instalment is highest at the start and falls as the debt decreases.',
  'pkn.gj.annuityHint': 'Annuity loan: the same instalment throughout the term — the principal portion grows while the interest portion falls.',
  'pkn.gj.postedAs': 'Interest and repayments on this loan are shown as "{category}" in Spending.',
  'pkn.gj.categoryFallback': 'category',
  'pkn.gj.loanFallback': 'Loan',
  'pkn.gj.editNamed': 'Edit {name}',
  'pkn.gj.observedIn': 'Observed in {count} transactions',
  'pkn.gj.calculatedFrom': 'Calculated from the loan details',
  'pkn.gj.observed': 'observed',
  'pkn.gj.highestEffective': 'Highest effective interest ({rate}) — costs an estimated {interest} in interest per year.',
  'pkn.gj.highest': 'Highest interest ({rate}) — costs an estimated {interest} in interest per year.',
  'pkn.gj.laterLoan': 'Interest {rate} · estimated {interest} in interest per year. Take this one once the more expensive loans are paid off.',
  'pkn.gj.bufferFirst': 'First finish building the cash buffer. It is missing',
  'pkn.gj.bufferFirstSuffix': 'to reach the buffer target before extra repayment should be prioritised.',
  'pkn.gj.snowA': 'pay the minimum on everything, but put extra money on',
  'pkn.gj.snowB': 'at {rate} interest first. When it is paid off, move the amount to the next most expensive one.',
  'pkn.gj.planTitle': 'Repayment plan · {name}',
  'pkn.gj.extraPerMonth': '{amount} extra per month',
  'pkn.gj.makesDebtFree': 'makes you debt-free on {name}',
  'pkn.gj.earlier': '{time} earlier',
  'pkn.gj.andKeep': 'and lets you keep',
  'pkn.gj.toBank': 'that would otherwise have gone to the bank in interest.',
  'pkn.gj.activated': 'Activated',
  'pkn.gj.tryRecommendation': 'Try the recommendation',
  'pkn.gj.standard': 'Standard',
  'pkn.gj.heroEarlier': 'You become debt-free sooner',
  'pkn.gj.heroLonger': 'This extends the term',
  'pkn.gj.heroDrag': 'Drag the slider and see what happens',
  'pkn.gj.earlierWord': 'earlier',
  'pkn.gj.laterWord': 'later',
  'pkn.gj.interestSaved': 'Saved in interest',
  'pkn.gj.interestMore': 'More in interest',
  'pkn.gj.paymentNow': 'Instalment now',
  'pkn.gj.newMonthlyPayment': 'New monthly payment',
  'pkn.gj.declines': 'Falls as the debt decreases',
  'pkn.gj.standardAmount': 'Standard {amount}',
  'pkn.gj.timeLeft': '{time} left',
  'pkn.gj.inSpendingSuffix': 'in Spending, so you can easily tell the loan apart from the rest of your expenses.',
  'pkn.ov.tone.insight': 'Insight',
  'pkn.ov.tone.milestone': 'Milestone',
  'pkn.ov.tone.opportunity': 'Opportunity',
  'pkn.ov.tone.tax': 'Tax',
  'pkn.ov.tone.save': 'Save money',
  'pkn.ov.tone.alert': 'Alert',
  'pkn.ov.verdict.healthy': 'Healthy finances',
  'pkn.ov.verdict.stable': 'Stable finances',
  'pkn.ov.verdict.needsFollowUp': 'Needs follow-up',
  'pkn.ov.stat.finances': 'Finances',
  'pkn.ov.stat.potentialSaving': 'Potential saving',
  'pkn.ov.stat.needsFollowUp': 'Needs follow-up',
  'pkn.ov.things': '{count} items',
  'pkn.ov.stat.healthScore': 'Health score',
  'pkn.ov.goToTopTask': 'Go to the most important task',
  'pkn.ov.allDone': 'All done',
  'pkn.ov.noneYet': 'None yet',
  'pkn.ov.remainingCount': '{count} left',
  'pkn.ov.howAdviceCalculated': 'How the advice was calculated',
  'pkn.ov.showFewer': 'Show fewer tasks',
  'pkn.ov.seeAll': 'See all tasks ({count})',
  'pkn.ov.noNewTasks': 'No new tasks right now. Upload more account statements for a more reliable and up-to-date picture.',
  'pkn.ov.allTicked': 'Everything is ticked off for today. I will keep watching and let you know when something happens.',
  'pkn.ov.doneToday': 'Completed today · {count}',
  'pkn.ov.completed': 'completed',
  'pkn.ov.hidden': 'hidden',
  'pkn.ov.group.wealth': 'Wealth and balance',
  'pkn.ov.group.cashflow': 'Monthly cash flow',
  'pkn.ov.preliminary': 'Preliminary · the data basis is incomplete',
  'pkn.ov.sinceLastMonth': 'since last month',
  'pkn.ov.bestEver': 'Best ever: {score}',
  'pkn.ov.trendMonths': 'Trend over the last {count} months',
  'pkn.ov.mascotAlt': 'SuperPlumma with a growing plant',
  'pkn.ov.howKpisCalculated': 'How the key figures are calculated',
  'pkn.ov.kpiExplanation': 'In is registered income. Out is ordinary spending. Net cash flow is income minus ordinary spending, loan payments and saving/investing. Your own transfers and credit card settlements are excluded. Assets and debt can be reconciled against the registers on their respective pages.',
  'pkn.ov.noScoreA': 'I cannot set a health score for your finances until I have figures to work with',
  'pkn.ov.noScoreB': 'Upload an account statement under Import — and I will analyse income, spending, savings and debt, and tell you how you are doing.',
  'pkn.ov.andChanged': 'and has changed by',
  'pkn.ov.points': 'points',
  'pkn.ov.thinBasis': 'Note that the basis is still thin — more imported months give a more reliable picture.',
  'pkn.ov.watchExtra': 'The one thing I am keeping an extra eye on is',
  'pkn.rpt.verdict.strong': 'Strong month',
  'pkn.rpt.verdict.solid': 'Solid month',
  'pkn.rpt.verdict.fine': 'Decent month',
  'pkn.rpt.verdict.mixed': 'Mixed month',
  'pkn.rpt.verdict.demanding': 'Demanding month',
  'pkn.rpt.wholeYear': 'All of {year}',
  'pkn.rpt.ppVs': '{delta} pp vs {year}',
  'pkn.rpt.pctVs': '{pct} vs {year}',
  'pkn.rpt.empty.bad': 'Without imported transactions I cannot point out what should be improved.',
  'pkn.rpt.empty.focus': 'Upload an account statement under Import, and I will write a full summary of the period for you.',
  'pkn.rpt.empty.good': 'Nothing to assess yet.',
  'pkn.rpt.empty.lead': 'I have no imported transactions for {period} yet, so I cannot write a summary of the period. Upload an account statement under Import, and I will read the figures and tell you how the month went.',
  'pkn.rpt.moverUp': 'What moved the most was {name}, which increased by {amount} compared with {period}.',
  'pkn.rpt.moverDown': 'What moved the most was {name}, which fell by {amount} compared with {period}.',
  'pkn.rpt.strengthYes': 'Compared with {period} you have strengthened your finances this period.',
  'pkn.rpt.strengthNo': 'Compared with {period} you have used a little more of your surplus this period.',
  'pkn.rpt.rhythm.healthy': 'That is a healthy rhythm to keep up — you are building security month by month.',
  'pkn.rpt.rhythm.fine': 'That is a decent rhythm, but there is room to set aside a little more.',
  'pkn.rpt.rhythm.low': 'Here it is worth checking whether something can be freed up for saving next month.',
  'pkn.rpt.leadNamed': '{name}, in {period} you had {income} coming in and {cost} in ordinary spending. After spending, debt payments and registered saving, net cash flow was {saved}. Registered saving made up {rate} % of income.',
  'pkn.rpt.lead': 'In {period} you had {income} coming in and {cost} in ordinary spending. After spending, debt payments and registered saving, net cash flow was {saved}. Registered saving made up {rate} % of income.',
  'pkn.rpt.good.incomeUp': 'Income increased {pct} compared with {year}.',
  'pkn.rpt.good.rateUp': 'The savings rate rose from {from} % to {to} %.',
  'pkn.rpt.good.costDown': 'Costs fell {pct} — lower than the same period last year.',
  'pkn.rpt.good.lessOn': 'You spent {amount} less on {name}.',
  'pkn.rpt.good.rateHealthy': 'A savings rate of {rate} % is healthy — above the recommended threshold of 20 %.',
  'pkn.rpt.good.fixedStable': 'Fixed expenses remain stable throughout the period.',
  'pkn.rpt.bad.costUp': 'Costs increased {pct} compared with {year}.',
  'pkn.rpt.bad.rateDown': 'The savings rate fell from {from} % to {to} %.',
  'pkn.rpt.bad.mostUp': '{name} increased the most — {pct} ({amount} more).',
  'pkn.rpt.bad.incomeLower': 'Income was {pct} lower than last year.',
  'pkn.rpt.bad.rateLow': 'A savings rate of {rate} % is a bit low — try to set aside more next month.',
  'pkn.rpt.bad.nothing': 'Nothing stands out negatively this period.',
  'pkn.rpt.focus.watch': 'Keep an eye on {name} next month — this is where spending increased the most, and a small adjustment has the fastest effect.',
  'pkn.rpt.focus.biggest': '{name} is your biggest expense item. See whether something can be trimmed there without your daily life noticing.',
  'pkn.rpt.focus.continue': 'Carry on in the same track next month and consider moving a bit more of the surplus straight to a savings goal.',
  'pkn.rpt.obs.highestIncome': 'Highest income of the year so far — {amount}.',
  'pkn.rpt.obs.lowestCost': 'Lowest monthly cost so far this year.',
  'pkn.rpt.obs.streak': '{count} months in a row with a surplus — you are saving steadily.',
  'pkn.rpt.obs.deviationOver': 'Spending is {pct} % above the average for the three previous months.',
  'pkn.rpt.obs.deviationUnder': 'Spending is {pct} % below the average for the three previous months.',
  'pkn.rpt.obs.standsOut': '{name} stands out — {pct} vs {year}.',
  'pkn.rpt.obs.setAside': 'You set aside {amount} through {year}.',
  'pkn.rpt.obs.yearIncome': 'Annual income is {pct} vs {year}.',
  'pkn.rpt.ask.why': 'Why did {name} change this period?',
  'pkn.rpt.ask.spendingFallback': 'spending',
  'pkn.rpt.ask.saveMore': 'What should I do to save more?',
  'pkn.rpt.ask.vsLastYear': 'How am I doing compared with last year?',
  'pkn.rpt.ask.rateEnough': 'Is my savings rate good enough?',
  'pkn.rpt.ask.whatIfContinue': 'What happens if I carry on like this?',
  'pkn.rpt.opening': 'Opening print …',
  'pkn.rpt.monthly': 'Monthly',
  'pkn.rpt.yearly': 'Yearly',
  'pkn.rpt.off': 'Off',
  'pkn.rpt.monthReport': 'Monthly report',
  'pkn.rpt.yearReport': 'Annual report',
  'pkn.rpt.basedOnBank': 'personal finance · based on imported bank data',
  'pkn.rpt.comparedWith': 'compared with {period}',
  'pkn.rpt.writtenForYou': 'Written for you · {period}',
  'pkn.rpt.askPlaceholder': 'Ask about the report …',
  'pkn.rpt.netCashflow': 'Net cash flow',
  'pkn.rpt.incomeCostPerMonth': 'Income and costs per month · {year}',
  'pkn.rpt.outlookSub': 'If the development from {period} continues over the next year',
  'pkn.rpt.outlookNoteA': 'If you carry on at the same pace as in {period}, net cash flow could be around',
  'pkn.rpt.outlookNoteB': 'over the next year. Small adjustments now can make the curve steeper.',
  'pkn.rpt.footerNote': 'The reports are generated from imported account and card statements. Earlier years are available as long as the data has been read in. The comparison shows the same period the year before.',
  'pkn.tax.prob.veryLikely': 'Very likely',
  'pkn.tax.prob.likely': 'Likely',
  'pkn.tax.prob.possible': 'Possible',
  'pkn.tax.prob.uncertain': 'Uncertain',
  'pkn.tax.heroTag': 'SuperPlumma\'s tax summary for {year}',
  'pkn.tax.leadNoEstimate': 'I use registered income, debt, wealth and family situation as the basis for checking {year}. I do not show an estimated tax amount without a complete, verified tax basis.',
  'pkn.tax.leadEstimateA': 'I have been through your tax information for {year}. I expect to reduce your tax by around',
  'pkn.tax.leadEstimateB': 'and I have prioritised the measures that matter most right now.',
  'pkn.tax.heroMeta': 'Tax year {year} · rule set {rules} · estimates must be checked against Skatteetaten',
  'pkn.tax.unversioned': 'not versioned',
  'pkn.tax.actionsFound': '{count} measures found',
  'pkn.tax.noActionsFound': 'No measures found yet',
  'pkn.tax.returnDeadline': 'Tax return · deadline 30 April',
  'pkn.tax.noDeductions': 'No deductions are documented securely enough to calculate a tax benefit. Use the wizard as a checklist and compare with Skatteetaten\'s pre-filled information and official guidance.',
  'pkn.tax.provisionalEffect': 'Preliminary calculated tax effect: {amount}.',
  'pkn.tax.checkpointsFound': '{count} checkpoints found.',
  'pkn.tax.onlyCandidatesNote': 'Only candidates with sufficient information have an amount. The rest show what you need to answer or document.',
  'pkn.tax.showSignalTx': 'Show the transactions that gave the signal',
  'pkn.tax.unknownDate': 'Unknown date',
  'pkn.tax.missingHeading': 'This is missing',
  'pkn.tax.readRule': 'Read the rule at Skatteetaten',
  'pkn.tax.statusLabel': 'Status',
  'pkn.tax.mustClarify': 'Needs clarification',
  'pkn.tax.noOptimisations': 'No tax measures are suggested without documented grounds and a current rule source. Check larger decisions against Skatteetaten\'s guidance or an authorised adviser.',
  'pkn.tax.effectThisYear': 'Effect this year ({year})',
  'pkn.tax.disclaimer': 'The suggestions are automatically generated estimates based on your information and the current tax rules. They are not individual tax advice. You are responsible for the content of the tax return — contact an authorised adviser for larger decisions.',
  'pkn.tax.reviewEmpty': 'The tax check goes through income, debt, wealth, investments, family and deductions and flags what is missing or should be checked. The check runs as soon as the tax information has been fetched.',
  'pkn.tax.level.missing': 'Missing',
  'pkn.tax.level.check': 'Check',
  'pkn.tax.level.ok': 'OK',
  'pkn.tax.checklist.income': 'Income reviewed',
  'pkn.tax.checklist.debt': 'Debt reviewed',
  'pkn.tax.checklist.wealth': 'Wealth reviewed',
  'pkn.tax.checklist.investments': 'Investments reviewed',
  'pkn.tax.checklist.deductions': 'Deductions reviewed',
  'pkn.tax.checklist.family': 'Family information reviewed',
  'pkn.tax.pointsRemain': 'points remain',
  'pkn.tax.pointsLeft': 'points left',
  'pkn.tax.qualityAssured': '{score} % quality assured',
  'pkn.tax.missingWhenConnected': 'Once income, debt, wealth and family information are connected, I will show exactly what is missing for full certainty.',
  'pkn.tax.goThere': 'Go there',
  'pkn.tw.noInfo': 'No reliable information has been fetched for this step yet. Select the relevant circumstances in the wizard and check them against annual statements and the tax return.',
  'pkn.tw.pickAll': 'Select everything that applied in the tax year. Your choices determine which check questions you get.',
  'pkn.tw.situation.enslig': 'Single',
  'pkn.tw.situation.gift': 'Married',
  'pkn.tw.situation.samboer': 'Cohabiting partner',
  'pkn.tw.situation.barn': 'Children',
  'pkn.tw.situation.student': 'Student',
  'pkn.tw.situation.pensjonist': 'Pensioner',
  'pkn.tw.situation.naering': 'Self-employed',
  'pkn.tw.topic.union': 'I paid trade union fees',
  'pkn.tw.topic.commuter': 'I stayed overnight away because of work',
  'pkn.tw.topic.refinancing': 'I refinanced loans',
  'pkn.tw.topic.debt-interest': 'I had loans or loan costs that need to be checked',
  'pkn.tw.topic.bsu': 'I deposited money into a BSU account',
  'pkn.tw.topic.ips': 'I deposited money into an IPS account',
  'pkn.tw.topic.gifts': 'I gave gifts to voluntary organisations',
  'pkn.tw.topic.share-loss': 'I sold shares or securities at a loss',
  'pkn.tw.topic.property-loss': 'I sold a home or holiday home at a loss',
  'pkn.tw.topic.rental-costs': 'I had taxable rental income',
  'pkn.tw.topic.foreign-tax': 'I paid tax abroad',
  'pkn.tw.topic.home-office': 'I had a separate room used only as a home office',
  'pkn.tw.topic.actual-work-costs': 'My actual work costs may be higher than the standard minimum deduction',
  'pkn.tw.topic.job-move': 'I moved because of a new job',
  'pkn.tw.topic.education': 'I paid for work-related education',
  'pkn.tw.topic.doctorate': 'I had costs for a doctoral defence',
  'pkn.tw.topic.fisher': 'I worked as a fisher',
  'pkn.tw.topic.seafarer': 'I worked as a seafarer',
  'pkn.tw.topic.young-worker': 'Skatteetaten selected me for the trial of the work deduction for young people',
  'pkn.tw.topic.co-op-housing': 'I owned a home in a housing cooperative, housing company or condominium',
  'pkn.tw.topic.foreign-worker': 'I was a foreign worker',
  'pkn.tw.topic.partial-year': 'I lived in Norway for only part of the year',
  'pkn.tw.topic.hobby-income': 'I had a hobby, odd jobs or other extra income',
  'pkn.tw.commuted': 'I travelled between home and a fixed workplace',
  'pkn.tw.fuelNote': 'Fuel expenses are only used as a signal. The calculation uses the shortest distance and actual travel days. Home office days must not be counted.',
  'pkn.tw.homeAddress': 'Home address',
  'pkn.tw.workAddress': 'Address of fixed workplace',
  'pkn.tw.shortestDistance': 'Shortest distance one way',
  'pkn.tw.travelDays': 'Actual travel days',
  'pkn.tw.presetFullTime': 'Full time · 230 days',
  'pkn.tw.presetHalfTime': '50 % · 115 days',
  'pkn.tw.presetCustom': 'Own number',
  'pkn.tw.distanceChecked': 'I have checked the shortest distance between the addresses',
  'pkn.tw.tollFerry': 'Documented toll/ferry costs (checked separately)',
  'pkn.tw.childrenNote': 'Children do not automatically give a deduction. State children who were 11 years or younger at the end of the tax year, and documented costs for childcare.',
  'pkn.tw.childrenUnder12': 'Children aged 11 or younger',
  'pkn.tw.childrenSpecial': 'Children 12+ with special care needs',
  'pkn.tw.childcareCosts': 'Documented childcare costs',
  'pkn.tw.navSupport': 'Childcare benefit from NAV',
  'pkn.tw.extraKm': 'Extra km per day for childcare',
  'pkn.tw.extraDays': 'Days with extra transport',
  'pkn.tw.bankReports': 'Banks and providers report a lot automatically. Tick the circumstances that still need to be reconciled.',
  'pkn.tw.deductionsFound': '{count} possible deductions or checkpoints have been found.',
  'pkn.tw.noCandidates': 'No candidates have been found yet.',
  'pkn.tw.amountsNote': 'Amounts are only shown when the basis can be calculated. The rest are questions that must be checked.',
  'pkn.tw.finishNote': 'Finish means that you have gone through the questions — not that the deductions are approved or that the tax return is ready to be filed.',
  'pkn.tw.sub': 'Comprehensive check for the tax year {year}',
  'pkn.tw.stepWord': 'Step',
  'pkn.tw.checklistReviewed': 'The tax checklist has been reviewed',
});
